import { motion } from 'framer-motion';
import { useSeoMeta } from '@unhead/react';
import { CreateFundraiserForm } from '@/components/CreateFundraiserForm';
import { Header } from '@/components/Header';

export default function CreateFundraiser() {
  useSeoMeta({
    title: 'Create Campaign - ZapFunder',
    description: 'Launch your crowdfunding campaign on Nostr',
  });

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-50">
      <Header />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="mb-10 text-center"
        >
          <h1 className="text-5xl font-black text-black mb-4 tracking-tight">
            Create Your Campaign
          </h1>
          <p className="text-xl text-gray-700 font-semibold">
            Launch your fundraiser and start raising sats from the Nostr community.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: 'easeOut' }}
        >
          <CreateFundraiserForm />
        </motion.div>
      </main>
    </div>
  );
}
